<template>
  <div class="dnn-download-box">
    <el-tooltip
      class="item"
      effect="dark"
      :content="
        fileUrl
          ? fileName
            ? fileName
            : btnLabel
          : 'No download files available at the moment'
      "
      placement="top"
    >
      <el-button
        class="dnn-downLoadBtn"
        :loading="loading"
        :icon="icon"
        @click="downLoad"
        v-if="btnType === 'btn'"
        :disabled="!fileUrl"
        >{{ btnLabel }}</el-button
      >
      <el-button class="dnn-downLoadBtn-text" type="text" v-else>{{
        btnLabel
      }}</el-button>

      
    </el-tooltip>
  </div>
</template>

<script>
import { downLoadFile } from "@/api/api";
import { downLoadCount } from "@/api/website";
export default {
  name: "DownLoad",
  props: {
    fileUrl: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      default: "0",
    },
    type: {
      type: String,
      default: "1",
    },
    fileName: {
      type: String,
      required: "file",
    },
    btnLabel: {
      type: String,
      default: "Download",
    },
    icon: {
      type: String,
      default: "el-icon-download",
    },
    btnType: {
      type: String,
      default: "btn", // text文字按钮
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    downLoad() {
      console.log("this.fileUrl--", this.fileUrl);
      console.log("this.fileName--", this.fileName);
      if (!this.fileUrl) return;
      this.loading = true;
      downLoadFile(this.fileUrl)
        .then((res) => {
          // let fileName = this.$uniFun.getFileName(this.fileUrl);
          this.$uniFun.downloadFile(res, this.fileName);
        })
        .catch((e) => {
          console.log("err--", err);
          this.$message.error("资源请求错误");
        })
        .finally(() => {
          this.loading = false;
          downLoadCount({
            type: this.type,
            id: this.id,
          });
        });
    },
    async downloadByUrl() {
      try {
        console.log("this.fileUrl++", this.fileUrl);
        console.log("this.fileUrl++", this.fileName);
        if (!this.fileUrl) return;
        this.loading = true;
        const response = await fetch(this.fileUrl);
        const blob = await response.blob();
        const tempUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = tempUrl;
        a.download = this.fileName;
        a.click();
        URL.revokeObjectURL(tempUrl); // 释放内存
        this.loading = false;
      } catch (error) {
        console.error("下载失败:", error);
        this.loading = false;
      }
    },
    async downloadLargeFile() {
      console.log("this.fileUrl++", this.fileUrl);
      console.log("this.fileUrl++", this.fileName);
      if (!this.fileUrl) return;
      this.loading = true;
      const response = await fetch(this.fileUrl);
      const reader = response.body.getReader();
      let chunks = [];
      let totalSize = 0;

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        chunks.push(value);
        totalSize += value.length;
        console.log(`已下载: ${(totalSize / (1024 * 1024)).toFixed(2)}MB`);
      }

      const blob = new Blob(chunks);
      const downloadUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = this.fileName;
      a.click();
      URL.revokeObjectURL(downloadUrl);
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
.dnn-download-box {
  display: inline-block;
  .dnn-downLoadBtn {
    padding: 8px 12px;
    border-color: #1d1d1f;
    color: #1d1d1f;
    font-size: 14px;
    &:hover {
      background: transparent;
      border-color: #0035fb;
      color: #0035fb;
    }
    &:focus {
      border-color: #1d1d1f;
      color: #1d1d1f;
      background: transparent;
    }
  }
  .dnn-downLoadBtn-text.el-button--text {
    display: block;
    padding: 0;
    color: rgba(255, 255, 255, 0.6);
    background: transparent;
    &:hover {
      color: #0035fb;
      text-decoration: underline;
    }
    &.el-button + .el-button {
      margin: 0;
    }
  }
}
</style>
